export const GET_BOARD_IMPORT_EXPORT_PROFILES = "GET_BOARD_IMPORT_EXPORT_PROFILES";
export const SET_BOARD_IMPORT_EXPORT_PREVIEW = "SET_BOARD_IMPORT_EXPORT_PREVIEW";
export const SET_BOARD_IMPORT_EXPORT_RESULT = "SET_BOARD_IMPORT_EXPORT_RESULT";
export const SET_BOARD_IMPORT_EXPORT_LOADING = "SET_BOARD_IMPORT_EXPORT_LOADING";
export const CLEAR_BOARD_IMPORT_EXPORT_STATE = "CLEAR_BOARD_IMPORT_EXPORT_STATE";
